import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Modal from "antd/es/modal";
import Draggable from "react-draggable";

const BtcViewModal = ({ show, onClose, doorId }) => {
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });
  const [iframeUrl, setIframeUrl] = useState("");
  const dragRef = useRef(null);

  useEffect(() => {
    if (show) {
      const { searchParams: queryParams } = new URL(window.location.href);
      const hwId = queryParams.get("hwId");

      const origin = window.location.origin;
      const url = `${origin}/monitor/${doorId || hwId}${
        hwId ? "?hw_id=" + hwId : ""
      }`;
      setIframeUrl(url);
    }
  }, [show, doorId]);

  return (
    <StyledBtcViewModal
      title="BTC View"
      visible={show}
      onCancel={() => {
        onClose && onClose();
      }}
      width={684}
      bodyStyle={{ height: "384px" }}
      centered={true}
      footer={null}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable
          handle=".ant-modal-header"
          bounds={bounds}
          onStart={(event, uiData) => {
            const { clientWidth, clientHeight } = document.documentElement;
            const targetRect = dragRef.current?.getBoundingClientRect();
            if (!targetRect) return;
            setBounds({
              left: -targetRect.left + uiData.x,
              right: clientWidth - (targetRect.right - uiData.x),
              top: -targetRect.top + uiData.y,
              bottom: clientHeight - (targetRect.bottom - uiData.y),
            });
          }}
        >
          <div ref={dragRef}>{modal}</div>
        </Draggable>
      )}
    >
      <IframeContainer>
        <iframe
          src={iframeUrl}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          title="BTC Monitor"
        />
      </IframeContainer>
    </StyledBtcViewModal>
  );
};

const StyledBtcViewModal = styled(Modal)`
  .ant-modal-header {
    cursor: move;
  }
  .ant-modal-body {
    height: 480px;
    padding: 0;
  }
  .ant-modal-content {
    height: auto;
  }
`;

const IframeContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 20px;
  background-color: white;
  box-sizing: border-box;
`;

export default BtcViewModal;
